import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { get } from "../../utility/fetch";

const UnpaidServices = forwardRef(({ payload, appointmentId }, ref) => {
  const [showTable, setShowTable] = useState(false);
  const [isServicePaid, setIsServicePaid] = useState(true);
  const [unpaidServices, setUnpaidServices] = useState([]);

  const getVitalsByAppointmentId = async (id) => {
    try {
      let res = await get(
        `/patients/vital-service-by-appointmentId?appointmentId=${id}`,
      );
      console.log("Unpaid Services Response:", res?.data);
      setIsServicePaid(res.data);
      setUnpaidServices(res.data);
    } catch (error) {
      console.error("Error fetching visitation details:", error);
    }
  };

  useImperativeHandle(ref, () => ({
    refresh: () => {
      if (appointmentId) getVitalsByAppointmentId(appointmentId);
    },
  }));

  useEffect(() => {
    if (appointmentId) {
      getVitalsByAppointmentId(appointmentId);
    }
  }, [appointmentId]);

  return (
    <div className="w-100">
      <div>
        {
          // !showTable &&
          isServicePaid && // Show alert stripe if appointmentId
            payload?.appointmentId &&
            unpaidServices?.length > 0 && (
              <div className="alert-container">
                {/* <p>Patient has one or more unpaid services.</p> */}
              </div>
            )
        }
      </div>

      {
        // Show table after clicking "View"
        isServicePaid && (
          <div className=" w-100">
            <h3>Additional Services By Appointment</h3>
            <table className="bordered-table w-100">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Service</th>
                  {/* <th>Amount</th> */}
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {unpaidServices?.map((service, index) => (
                  <tr key={index}>
                    <td>{service.categoryName}</td>
                    <td>{service.categoryItem}</td>
                    {/* <td>${service.amount}</td> */}
                    <td>{service.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      }
    </div>
  );
});

export default UnpaidServices;

// export default UnpaidServices;
